const cutoffHour = 13;
const deliveryDays = 1;
const dateNow = new Date();
let deliveryDate = new Date(dateNow);

const ukHolidays = [
  new Date(dateNow.getFullYear(), 0, 1),  // New Year's Day
  new Date(dateNow.getFullYear(), 3, 3),  // Good Friday
  new Date(dateNow.getFullYear(), 3, 6),  // Easter Monday
  new Date(dateNow.getFullYear(), 4, 4),  // Early May Bank Holiday
  new Date(dateNow.getFullYear(), 4, 25),  // Spring Bank Holiday
  new Date(dateNow.getFullYear(), 7, 31), // Summer Bank Holiday
  new Date(dateNow.getFullYear(), 11, 25), // Christmas Day
  new Date(dateNow.getFullYear(), 11, 26), // Boxing Day
];

function isWorkingDay(date) {
  const day = date.getDay();
  const isWeekend = (day === 0 || day === 6);
  const isHoliday = ukHolidays.some(h => h.toDateString() === date.toDateString());
  return !isWeekend && !isHoliday;
}

function getNextDispatchDate(currentDate) {
  const dispatchDate = new Date(currentDate);

  // If it's after cutoff time, move to next day
  if (currentDate.getHours() >= cutoffHour || currentDate.getDay() === 6 || currentDate.getDay() === 0) {
    dispatchDate.setDate(dispatchDate.getDate() + 1);
  }

  // Keep moving to the next day until it's a valid dispatch day
  while (!isWorkingDay(dispatchDate)) {
    dispatchDate.setDate(dispatchDate.getDate() + 1);
  }

  return dispatchDate;
}

function getDeliveryDateFrom(dispatchDate) {
  const deliveryDate = new Date(dispatchDate);
  deliveryDate.setDate(deliveryDate.getDate() + deliveryDays);

  // Skip to next working day if delivery day is not valid
  while (!isWorkingDay(deliveryDate)) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  return deliveryDate;
}

const dispatchDate = getNextDispatchDate(dateNow);
const finalDeliveryDate = getDeliveryDateFrom(dispatchDate);

const formattedDate = finalDeliveryDate.toLocaleString('en-GB', {
  weekday: 'short',
  day: 'numeric',
  month: 'short'
});

const deliveryOutput = `Order ${dateNow.getHours() < cutoffHour && isWorkingDay(dateNow) ? 'by 1PM' : 'today'}. <div>Delivers <strong>${formattedDate}</strong> — with <strong>Express</strong></div>`;

document.getElementById('delivery-date').innerHTML = deliveryOutput;
